<script setup lang="ts">
const { t } = useEkI18n();
const settingsStore = useSettingsStore();

async function updateDescriptionPreference(value: boolean) {
  await settingsStore.set('worksheetsShowDescription', value);
}
</script>

<template>
  <SettingsToggle
    :checked="settingsStore.settings.worksheetsShowDescription"
    :label="t('settings.worksheets.showWorkDescription')"
    :description="t('settings.worksheets.showWorkDescriptionDescription')"
    @change="updateDescriptionPreference"
  />
</template>

<style scoped>
</style>
